import React, { useState, useEffect, useRef } from "react";
import { useSelector } from 'react-redux';
import LocalizedLink from 'helpers/LocalizeLink';
import { useLocation } from 'react-router-dom';
import { getLocaleLink } from 'helpers/util';

const HeaderNavMenu = () => {
    const menuItems = useSelector(store => store.menus);

    const getHeaderMenuItems = (() => {
        return menuItems?.length > 0 ? menuItems.find((menu) => { return menu.type === "header" })?.menu_items : [];
    })

    const [visibleMenuItems, setVisibleMenuItems] = useState([]);
    const [hiddenMenuItems, setHiddenMenuItems] = useState([]);
    const [menuActive, setMenuActive] = useState(0);
    const [hiddenMenuActive, setHiddenMenuActive] = useState(false);
    const [showMenu] = useState(false);
    const location = useLocation();
    const mainMenuWrapper = useRef(null);
    const mainMenuInside = useRef(null);

    useEffect(() => {
        document.addEventListener("click", handleClick);
        window.addEventListener('resize', updateNavigation);

        return () => {
            document.removeEventListener("click", handleClick);
            window.removeEventListener('resize', updateNavigation);
        };
    });

    useEffect(() => {
        // Задерживаем расчет, чтобы DOM элементы успели отрендериться
        const timer = requestAnimationFrame(() => {
            updateNavigation();
        });
        return () => cancelAnimationFrame(timer);
    }, [menuItems])

    const handleClick = e => {
        if (e.target && e.target.classList.contains('has_submenu')) {
            setMenuActive(parseInt(e.target.hash.slice(1)));
        } else {
            setMenuActive(0);
        }

        if (e.target && !e.target.classList.contains('hidden__menu--btn')) {
            setHiddenMenuActive(false);
        }
    };

    const { pathname } = location;
    const splitLocation = pathname.split("/");

    const isActive = (path) => {
        return (splitLocation.length === 3 && splitLocation[2] === path) ? ' isActive' : ''
    }

    const getVisibleItemsCount = () => {
        try {
            const menuElement = document.getElementById("menu");
            if (!menuElement || !mainMenuInside.current) {
                return 999; // Если элемента нет, показываем все
            }
            
            const offset = 116 + 50 + 101;
            const currentMenuWidthLoc = Math.ceil(menuElement.getBoundingClientRect().width - offset);
            const mainLiItems = mainMenuInside.current.querySelectorAll(".head_menu-item");
            
            if (mainLiItems.length === 0) {
                return 999; // Если элементов нет, показываем все
            }
            
            let sum_items_width = 0;
            let count_items = 0;
            mainLiItems.forEach((item, i) => {
                const itemWidth = item.getBoundingClientRect().width;
                if (itemWidth > 0 && sum_items_width < currentMenuWidthLoc) {
                    sum_items_width = Math.ceil(sum_items_width + itemWidth);
                    count_items++;
                }
            })

            return count_items > 0 ? count_items : 999;
        } catch (e) {
            return 999; // На случай ошибки показываем все элементы
        }
    }

    const updateNavigation = () => {
        const headerItems = getHeaderMenuItems();
        if (window.screen.availWidth > 767) {
            const visibleItemsCount = getVisibleItemsCount();
            setVisibleMenuItems(headerItems?.filter((item, i) => { return i < visibleItemsCount }));
            setHiddenMenuItems(headerItems?.filter((item, i) => { return i >= visibleItemsCount }));
        } else {
            setVisibleMenuItems(headerItems);
            setHiddenMenuItems([]);
        }
    }

    const SubItems = ({ menu_item, dti }) => {
        return (
            <li key={'submenu_item' + menu_item.id} className={'head_menu-item px-2 mb-sm-12' + (menuActive === menu_item.id ? ' openSubMenu' : '')} >
                <a onClick={(e) => { e.preventDefault(); setMenuActive(menuActive > 0 ? 0 : menu_item.id); }}
                    href={'#' + menu_item.id}
                    data-test-id={dti ? dti : null}
                    className="has_submenu text-white text-medium text-sm-big text-semibold text-decoration-none">
                    {menu_item.name}
                    <span className={'m_submenu-arrow d-inline-block d-md-none pl-sm-12' + (menuActive === menu_item.id ? ' arrow_up' : '')}></span>
                </a>
                <ul className={'sub_menu mt-1 p-1' + (menuActive === menu_item.id ? ' isActive' : '')}
                    onClick={() => { setMenuActive(menuActive > 0 ? 0 : menu_item.id) }}>
                    {
                        menu_item.subitems.map((subitem, subitem_index) => (
                            subitem.menu_id === menu_item.menu_id ?
                                <li className={'sub_menu-item' + isActive(subitem.slug)} key={menu_item.id + "subitem_index" + subitem_index}>
                                    {
                                        subitem.slug.includes("platform") ?
                                            <a href={subitem.slug} data-test-id={"head-nav-sub-item-" + subitem_index} className="sub_menu-link text-white text-small text-sm-medium text- text-semibold px-2">{subitem.name}</a> :
                                            <LocalizedLink to={getLocaleLink(subitem.slug)} dti={"head-nav-sub-item-" + subitem_index} className="sub_menu-link text-white text-small text-sm-medium text-semibold px-2">{subitem.name}</LocalizedLink>
                                    }
                                </li> : null
                        ))
                    }
                </ul>
            </li>)
    }

    return (
        <nav ref={mainMenuWrapper} className="nav w-sm-100 text-sm-center">
            <ul ref={mainMenuInside} className={'head_menu d-flex flex-column flex-md-row' + (showMenu ? ' active' : '')}>
                {
                    (menuItems === undefined || menuItems === null || menuItems.length === 0) ? null :
                        menuItems.map((item, index_a) => (
                            item.type === 'header' ? visibleMenuItems.map((menu_item, index_b) => (
                                (menu_item.subitems === undefined || menu_item.subitems === null || menu_item.subitems.length === 0) ?
                                    <li key={'menu_item' + menu_item.id} className={'head_menu-item px-2 mb-sm-12' + isActive(menu_item.slug)} >
                                        {menu_item.slug.includes("platform") ?
                                            <a href={menu_item.slug} data-test-id={"head-nav-item-" + index_b} className="head_menu-link text-white text-medium text-semibold text-sm-big text-decoration-none">{menu_item.name}</a> :
                                            <LocalizedLink to={getLocaleLink(menu_item.slug)} dti={"head-nav-item-" + index_b} className="head_menu-link text-white text-medium text-semibold text-sm-big text-decoration-none">{menu_item.name}</LocalizedLink>}
                                    </li>
                                    :
                                    <SubItems menu_item={menu_item} key={'index_ab' + index_b + '_' + index_a} dti={"head-nav-item-" + index_b} />
                            )) : null
                        ))
                }
                {
                    hiddenMenuItems?.length > 0 && <li className='head_menu-item hidden--item px-12'>
                        <button
                            className="hidden__menu--btn text-white text-medium"
                            onClick={() => {
                                setHiddenMenuActive(!hiddenMenuActive);
                            }}
                        >• • •</button>
                        <ul className={"hidden__menu py-1" + (hiddenMenuActive ? ' isActive' : '')}>
                            {
                                hiddenMenuItems?.map((item, index) => <li key={`moreNavItem-${index}`} className="hidden__menu--item text-right mb-1 px-2">
                                    <a data-test-id={"head-nav-hide-item-" + index} className="hidden__menu--link text-white text-semibold text-decoration-none" href={item.slug}>{item.title}</a>
                                    {
                                        item?.subitems ?
                                            <ul className="hidden__submenu text-left">
                                                {
                                                    item.subitems.map((sub, i) =>
                                                        <li key={"hsmi" + i} className="hidden__submenu--item">
                                                            <a data-test-id={"head-nav-hide-subitem-" + i} href={sub.slug} className="hidden__submenu--link text-white text-decoration-none">{sub.title}</a>
                                                        </li>)
                                                }
                                            </ul>
                                            : null
                                    }
                                </li>)
                            }
                        </ul>
                    </li>
                }
            </ul>
        </nav>
    )
}

export default HeaderNavMenu;